// extracted by mini-css-extract-plugin
export default {"card":"ServicesCard_card__9AlxQ","icons":"ServicesCard_icons__lb3n5","title":"ServicesCard_title__jMfek","content":"ServicesCard_content__BAwBv"};